import { TemplateAppType } from "@/http";

type TemplateLink = {
  title: string;
  description: string;
  url: string;
  icon: string;
};

export const getTemplateLinks = (
  selectedApp: TemplateAppType | undefined,
  appSlug: string,
  access_token: string,
  appLoginToken: string
): TemplateLink[] => {
  if (!selectedApp) {
    return [];
  }

  return [
    {
      title: "Your Blog Website",
      description: "Visit your blog and view your first post!",
      url: `https://${appSlug}.${selectedApp.url}`,
      icon: "/pen-icon.svg",
    },
    {
      title: "Your Blog Dashboard",
      description: "Visit your dashboard to manage AI-generated posts.",
      url: `https://${appSlug}.${selectedApp.url}/validate?token=${appLoginToken}`,
      icon: "/calender-icon.svg",
    },
    {
      title: "AI Lab Dashboard",
      description: "Visit AI Lab Dashboard to customize your blog!",
      url: `${import.meta.env.VITE_AI_LAB_DASHBOARD_URL}?token=${access_token}`,
      icon: "/ai-sparkle-icon.svg",
    },
  ];
};
